export default __webpack_public_path__ + "static/media/SVPRO.185f3a95.png";